import { STATUS } from "@/constants/statuses";
import { Store, StoreConfig } from "@datorama/akita";

import type CartItem from "../entities/CartItemEntity";
import type { DiscountCodesEntity } from "../entities/DiscountCodesEntity";

export type CartState = {
    status: STATUS;
    items: CartItem[];
    discountCodes: DiscountCodesEntity[];
    editItemStatuses: {
        [variantId: number]: STATUS;
    };
};

const createInitialState = (): CartState => {
    return {
        status: STATUS.VIRGIN,
        items: [],
        discountCodes: [],
        editItemStatuses: {},
    };
};

@StoreConfig({
    name: "CartStore",
})
export class CartStore extends Store<CartState> {
    public constructor() {
        super(createInitialState());
    }
}
